import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MentorRoute = ({ children }) => {
  const { currentUser, isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // Check if user is a mentor
  if (currentUser && currentUser.membership_type === 'mentor') {
    return children;
  }
  
  // If not a mentor, redirect to home
  return <Navigate to="/" />;
};

export default MentorRoute;